import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import _ from 'lodash'

import Grid from '@material-ui/core/Grid'
import MenuItem from '@material-ui/core/MenuItem'
import { withStyles } from '@material-ui/core/styles';

import { ReferenceSelectInput } from '../Inputs'


const styles = {
  button: {
    icon: {
      marginRight: '10px'
    }
  }
}

class DatoTecnicoFilters extends Component {

    renderChoices(choices) {
        return _.map(choices, choice => {
        return (
            <MenuItem value={choice.value} key={choice.value}>
                {choice.text}
            </MenuItem>
        )
        })
    }

  render() {
    const {
      classes,
      handleSubmit,
    } = this.props

    return (
        <form
            onSubmit={handleSubmit(values => this.props.onSubmit(values))}
            className={classes.form}
        >
          <Grid container spacing={16}>
            <Grid item xs={12} md={2} lg={4}>
                <Field
                    name={"tipoDatoTecnico"}
                    label={"Tipo Dato Técnico"}
                    required={false}
                    component={ReferenceSelectInput}
                    reference={"esquemas-datos-tecnicos"}
                    optionText={"name"}
                    isDisabled={false}
                    onChange={this.props.onChange()}
                />
            </Grid>           
          </Grid>

        </form>
    )
  }
}

export default reduxForm({
    form: 'redux-form'
})(withStyles(styles)(DatoTecnicoFilters))
